import {TFunction} from 'i18next';
import {SECTION_ID_PARKING_LOTS, constructParkingLotFilter} from '../filterConstructors';
import {ParkingLotDto} from '@lib/infrastructure';

export const constructCalendarOverviewParkingFilter = (parkingLots: ParkingLotDto[], t: TFunction) => {
  const parkingLotFilters = constructParkingLotFilter(parkingLots, t);

  return {
    [SECTION_ID_PARKING_LOTS]: parkingLotFilters,
  };
};
